export const banners = [
  {
    id: "b1",
    workId: "1",
    title: "长夜将明",
    tag: "院线新片",
    subtitle: "一桩尘封十年的旧案，两位警察用十年等待黎明。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20crime%20film%20key%20art%2C%20lone%20figure%20walking%20down%20a%20rain-soaked%20neon%20city%20street%20at%20night%2C%20deep%20navy%20and%20amber%20glow%2C%20moody%20dramatic%20lighting%2C%20atmospheric%20painterly%20textured%20backdrop%2C%20no%20text&width=1600&height=900&seq=bg-01&orientation=landscape",
  },
  {
    id: "b2",
    workId: "10",
    title: "山河故梦",
    tag: "年度大剧",
    subtitle: "乱世之中，少年将军在山河破碎间追寻家国大义。",
    image:
      "https://readdy.ai/api/search-image?query=epic%20historical%20chinese%20drama%20key%20art%2C%20ancient%20warrior%20silhouette%20before%20misty%20mountains%20and%20a%20grand%20palace%20at%20dawn%2C%20deep%20jade%20ink%20and%20gold%20tones%2C%20cinematic%20painterly%20backdrop%2C%20no%20text&width=1600&height=900&seq=bg-02&orientation=landscape",
  },
  {
    id: "b3",
    workId: "3",
    title: "雾中列车",
    tag: "悬疑口碑",
    subtitle: "七名乘客，一场无法回头的推理。",
    image:
      "https://readdy.ai/api/search-image?query=mysterious%20thriller%20film%20key%20art%2C%20vintage%20train%20emerging%20from%20dense%20mountain%20fog%20under%20a%20single%20red%20signal%20light%2C%20cold%20teal%20and%20grey%20palette%2C%20cinematic%20painterly%20backdrop%2C%20no%20text&width=1600&height=900&seq=bg-03&orientation=landscape",
  },
  {
    id: "b4",
    workId: "18",
    title: "向往的田野",
    tag: "热播综艺",
    subtitle: "回到田野，用最朴素的方式过一段慢生活。",
    image:
      "https://readdy.ai/api/search-image?query=fresh%20lifestyle%20variety%20show%20key%20art%2C%20green%20terraced%20rice%20fields%20at%20sunny%20golden%20hour%20with%20distant%20mountains%2C%20vivid%20green%20sky%20blue%20and%20warm%20orange%20tones%2C%20joyful%20painterly%20backdrop%2C%20no%20text&width=1600&height=900&seq=bg-04&orientation=landscape",
  },
  {
    id: "b5",
    workId: "9",
    title: "深蓝之下",
    tag: "科幻巨制",
    subtitle: "深海科考队发现了不该存在的东西。",
    image:
      "https://readdy.ai/api/search-image?query=sci-fi%20mystery%20film%20key%20art%2C%20view%20into%20a%20glowing%20deep%20ocean%20trench%20with%20strange%20bio-luminescent%20lights%2C%20deep%20blue%20cyan%20and%20teal%20tones%2C%20cinematic%20painterly%20backdrop%2C%20no%20text&width=1600&height=900&seq=bg-05&orientation=landscape",
  },
];

export const hotKeywords = ["长夜将明", "山河故梦", "深蓝之下", "悬疑", "综艺", "古装"];